import { render, staticRenderFns } from "./LinkWo.vue?vue&type=template&id=728072c4"
import script from "./LinkWo.vue?vue&type=script&lang=js"
export * from "./LinkWo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports